import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ControlPanelModule } from './control-panel/control-panel.module';
import { PortalModule } from './portal/portal.module';
import { NgxPermissionsModule } from 'ngx-permissions';

// Components
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MainAppComponent } from './components/main-app/main-app.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { FooterComponent } from './components/footer/footer.component';
import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { TopNavbarComponent } from './components/top-navbar/top-navbar.component';
import { HomeComponent } from './components/home/home.component';
import { CompanySelectComponent } from './components/company-select/company-select.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';

// Providers
import { ConfigurationService } from './_services/configuration.service';
import { AuthenticationService } from './_services/authentication.service';
import { AuthGuard } from './_guards/auth.guard';
import { TokenInterceptor } from './_services/token-interceptor.service';
import { NavCollapseService } from './_services/nav-collapse.service';
import { UserProfileService } from './_services/user-profile.service';
import { PasswordResetService } from './_services/password-reset.service';
import { NavLinkAvailabilityService } from './_services/nav-link-availability.service';
import { PortalApiService } from './_services/portal-api.service';
import { PortalReportsService } from './_services/portal-reports.service';

export function loadConfigFactory(configService: ConfigurationService) {
  return (): Promise<any> => {
    return configService.loadConfigurationData();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    MainAppComponent,
    ForgotPasswordComponent,
    FooterComponent,
    SideNavbarComponent,
    TopNavbarComponent,
    HomeComponent,
    CompanySelectComponent,
    PasswordResetComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    SharedModule,
    ControlPanelModule,
    PortalModule
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    ConfigurationService,
    AuthenticationService,
    AuthGuard,
    NavCollapseService,
    UserProfileService,
    {
      /* Here we request that configuration loading be done at app-initialization time */
      provide: APP_INITIALIZER,
      useFactory: loadConfigFactory,
      deps: [ConfigurationService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    PasswordResetService,
    PortalApiService,
    PortalReportsService,
    NavLinkAvailabilityService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
